import { createContext, useContext, useRef, useEffect } from "react";

const AudioContext = createContext();

export function AudioProvider({ children }) {
  const audioRef = useRef(null);

  useEffect(() => {
    audioRef.current = new Audio("/UnPacto.mp3"); // ✅ CAMBIO ACÁ
    audioRef.current.loop = true;
    audioRef.current.volume = 0.5;
  }, []);

  const play = () => {
    if (audioRef.current) {
      audioRef.current.play().catch(() => {});
    }
  };

  const pause = () => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

  return (
    <AudioContext.Provider value={{ play, pause }}>
      {children}
    </AudioContext.Provider>
  );
}

export function useAudio() {
  return useContext(AudioContext);
}
